module.exports = __webpack_public_path__ + "fe394e457485738a38556b4d05778dd5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/game-controller.png
// module id = 2649
// module chunks = 0